import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import { CartProvider } from "react-use-cart";
import Home from "./pages/HomePage";
import Contact from "./pages/ContactPage";
import Products from "./pages/ProductsPage";
import Details from "./pages/ProductPage";
import Cart from "./pages/CheckoutPage";
import Checkout from "./pages/CheckoutSuccessPage";
import "./App.css";
import Layout from "./components/layout";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

function App() {
  return (
      <Router>
        <CartProvider>
        <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="contact" element={<Contact />} />
          <Route path="products" element={<Products />} />
          <Route path="products/:id" element={<Details />} />
          <Route path="cart" element={<Cart />} />
          <Route path="checkout" element={<Checkout />} />
        </Route>
      </Routes>
        </CartProvider>
      </Router>
  );
}

export default App;
